import markup from './tag-circle.component.html?raw';
import styles from './tag-circle.component.scss?inline';

const template = document.createElement('template');
template.innerHTML = `
  <style>${styles}</style>
  ${markup}
`;

class TagCircleElement extends HTMLElement {
  private readonly root: ShadowRoot;

  public constructor() {
    super();

    this.root = this.attachShadow({ mode: 'open' });
    this.root.appendChild(template.content.cloneNode(true));
  }

  static get observedAttributes(): string[] {
    return ['href', 'target', 'rel', 'title'];
  }

  public connectedCallback(): void {
    this.syncLink();
  }

  public attributeChangedCallback(_name: string, _oldValue: string | null, _newValue: string | null): void {
    void _name;
    void _oldValue;
    void _newValue;
    this.syncLink();
  }

  private syncLink(): void {
    const link = this.root.querySelector<HTMLAnchorElement>('.tag-circle');
    if (!link) {
      return;
    }

    const href = this.getAttribute('href')?.trim();
    const target = this.getAttribute('target')?.trim();
    const rel = this.getAttribute('rel')?.trim();
    const title = this.getAttribute('title')?.trim();

    if (href) {
      link.setAttribute('href', href);
      this.removeAttribute('aria-disabled');
    } else {
      link.removeAttribute('href');
      this.setAttribute('aria-disabled', 'true');
    }

    if (target) {
      link.setAttribute('target', target);
    } else {
      link.removeAttribute('target');
    }

    if (rel) {
      link.setAttribute('rel', rel);
    } else {
      link.removeAttribute('rel');
    }

    if (title) {
      link.setAttribute('title', title);
    } else {
      link.removeAttribute('title');
    }
  }
}

if (!customElements.get('tag-circle')) {
  customElements.define('tag-circle', TagCircleElement);
}
